import { isValidPhoneNumber as validatePhoneNumber } from 'react-phone-number-input/mobile';

export function isValidPhoneNumber(phoneNumber: string): boolean {
  return phoneNumber ? validatePhoneNumber(phoneNumber) : false;
}

export function isValidEmail(email: string): boolean {
  const emailPattern = /^\S+@\S+\.\S+$/;
  return emailPattern.test(email);
}
